import { render, staticRenderFns } from "./EditableTableItem.vue?vue&type=template&id=62216008&scoped=true&"
import script from "./EditableTableItem.vue?vue&type=script&lang=js&"
export * from "./EditableTableItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableTableItem.vue?vue&type=style&index=0&id=62216008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62216008",
  null
  
)

export default component.exports